import PropTypes from 'prop-types';
import { FormGroup, Label, TextField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './MedicaidField.module.scss';

const MedicaidField = ({ value, onChange, disabled }) => {
  const handleValueChange = event => onChange(event);

  return (
    <div className={styles.medicaidField}>
      <FormGroup>
        <Label size="sm" for={credentialForm.medicaidId}>
          {credentialForm.medicaidLabel}
        </Label>
        <TextField
          id={credentialForm.medicaidId}
          size="sm"
          value={value}
          onChange={handleValueChange}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  );
};

MedicaidField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

MedicaidField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
};

export default MedicaidField;
